import { render, staticRenderFns } from "./MitarbeiterArbeitszeiten.vue?vue&type=template&id=6a64d185"
import script from "./MitarbeiterArbeitszeiten.vue?vue&type=script&lang=js"
export * from "./MitarbeiterArbeitszeiten.vue?vue&type=script&lang=js"
import style0 from "./MitarbeiterArbeitszeiten.vue?vue&type=style&index=0&id=6a64d185&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VMenu,VRow,VSelect,VSpacer,VSwitch,VTextField,VTimePicker})
